export const Paginas = {
  HOME: "/",
};
